import React, { useState } from 'react';
import { InputComponent } from '../../core/Forms';
import * as UI from '../../common';
import View from '../../../assets/icons/svgicons/View.svg';
import { validateCreatePasswordForm } from '../../../modules/settings/settings';
import { Button } from '../../common';

interface Props {
  onSubmit: (formData: { currentPassword: string; newPassword: string }) => void;
}

export const CurrentPassword: React.FC<Props> = ({ onSubmit }) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isLoading, setIsLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState<string>('currentPassword');
  const [formData, setFormData] = useState({ currentPassword: '', newPassword: '' });

  const [validationResults, setValidationResults] = React.useState({
    currentPassword: '', 
    newPassword: '' 
  });

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const validationErrors = validateCreatePasswordForm(formData);
  
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        setIsLoading(false);
        return;
      }
      // If validation passed, continue with form submission
      await onSubmit(formData);
      setFormData({ currentPassword: '', newPassword: '' });
      setErrors({});
     
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' }); // Clear the error
  };

  return (
    <div className='w-full flex justify-center mt-[-1.3em] lg:mt-[1em] md:mt-[1em]'>
      <div className="bg-[#FFFFFF] min-h-screen mx-[-60px] sm:mx-0  sm:w-full w-[350px]  lg:w-full lg:mt-[-1em] lg:ml-[-1em] lg:h-screen ">
      <h1 className="text-[20px] lg:text-[20px] font-semibold lg:font-semibold pt-[20px] pl-[20px] sm:pl-[24px] lg:pl-[64px] lg:pt-[55px] ">Change Password</h1>
      <p className="text-[16px] lg:text-[16px] lg:font-sm pl-[20px] sm:pl-[24px] lg:pl-[64px] lg:pt-[7px] pb-[10px]">Secure your account with a strong password.</p>
      <hr className="lg:mt-[1em] lg:w-full" />
      <p className="text-[16px] ml-[-13.1em] md:ml-[2em] lg:text-[16px] font-sm lg:font-sm text-center lg:text-left pt-[20px] pl-[20px] lg:pl-[64px]  lg:pt-[11px]">Current Password</p>
      <form onSubmit={(event) => event.preventDefault()}>
        <div className="flex flex-col md:flex w-full md:flex-col justify-center lg:justify-start items-center lg:items-end sm:ml-0 mt-[24px] lg:pr-[64px]">
          <div className="  lg:mt-0">
            <label htmlFor="Password" className="text-[13px] text-black font-normal mt-">
              Password
            </label>
            <InputComponent
              placeholder="Old Password"
              name="currentPassword"
              type="password"
              value={formData.currentPassword}
              handleChange={handleInputChange}
              className="w-[310px] sm:w-[434px] md:w-[434px]"
              image={View}
              error={errors.currentPassword}
              imageClassName="xl:ml-[em] xl:mt-[-5em] ml-[17em] mt-[-5em] md:ml-[25em]"
            />
          </div>
        </div>

        <div className="flex flex-col md:flex md:flex-col md:w-full md:justify-center items-center lg:justify-end lg:items-end  mt-[2em]  lg:pr-[64px]">
          <div className="w-[310px] sm:w-[434px] md:w-[434px]">
            <Button
                      type="submit"
                      text="Change Password"
                      isLoading={isLoading}
                      disabled={isLoading}
                      onClick={handleSubmit}
                    />
          </div>
        </div>
      </form>
    </div>
    </div>
    
  );
};

export default CurrentPassword;
